import React, { useState } from "react";
import { FaCopy, FaExternalLinkAlt } from "react-icons/fa";

const ShareComponent = ({ userId, botId }) => {
  const [copied, setCopied] = useState(false);
  const iframeUrl = `${process.env.REACT_APP_CLIENT_APP}/v2/chatapp/${userId}/${botId}/true/false`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(iframeUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <div className=" w-full bg-gray-800 text-white p-6 rounded-lg shadow-lg ">
      <h3 className="text-xl 2xl:text-3xl font-semibold mb-2">Share</h3>
      <p className="text-gray-300 text-base 2xl:text-xl mb-4">
        To add the agent anywhere on your website, add this iframe to your HTML
        code:
      </p>
      <div className="bg-gray-900 p-4 rounded-lg flex items-center justify-between">
        <input
          type="text"
          value={iframeUrl}
          readOnly
          className="bg-transparent text-gray-300 text-base 2xl:text-xl text-center w-full border-none outline-none"
        />
        <button
          onClick={handleCopy}
          className="ml-3 text-gray-400 hover:text-white transition">
          <FaCopy size={18} />
        </button>
      </div>
      {copied && (
        <p className="text-green-400 text-sm 2xl:text-lg mt-2">
          Copied to clipboard!
        </p>
      )}
      <div className="mt-4 flex gap-3 text-bas 2xl:text-lg">
        <a
          href={iframeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition">
          Visit <FaExternalLinkAlt size={14} />
        </a>
      </div>
    </div>
  );
};

export default ShareComponent;
